import NotFound from '@/components/public/NotFound.vue';
import Login from '@/components/public/Login.vue';
import HowItWorks from '@/components/public/HowItWorks.vue';
import PasswordReset from "@/components/public/PasswordReset.vue";
import PasswordResetToken from "@/components/public/PasswordResetToken.vue";
import NotAllowed from "@/components/public/NotAllowed.vue";

let publicRoutes = [
    {
        path: '/login',
        name: 'public.login',
        component: Login,
        meta: {
            public: true,
            hideNavigation: true,
            allowInBrowser: true
        },
    },
    {
        path: '/how-it-works',
        name: 'public.howItWorks',
        component: HowItWorks,
        meta: {
            allowInBrowser: true,
            public: true,
            hideNavigation: true,
        },
    },
    {
        path: '/password/forgot',
        name: 'public.resetPassword',
        component: PasswordReset,
        meta: {
            public: true,
            hideNavigation: true,
            allowInBrowser: true
        },
    },
    {
        path: '/password/reset/:token',
        name: 'pages.passwordResetToken',
        component: PasswordResetToken,
        meta: {
            public: true,
            hideNavigation: true,
            allowInBrowser: true
        },
    },
    {
        path: '/not-allowed',
        name: 'public.notAllowed',
        component: NotAllowed,
        meta: {
            public: true,
            hideNavigation: true,
            allowInBrowser: true
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'pages.not.found',
        component: NotFound,
        meta: {
            public: true,
            hideNavigation: true,
            allowInBrowser: true
        },
    },
];

export {
    publicRoutes,
};
